import { createRoot } from 'react-dom/client';
import Auth from "@aws-amplify/auth";
import { DOMAIN_CONFIG_OBJ, QBOOK_URL } from "./utils/axiosInstance";
import { Provider } from "react-redux";
import store from "./reduxStore/store";
import App from "./app/App";
import { Helmet } from "react-helmet";
import { MathJaxContext } from "better-react-mathjax";
import { QBOOK_DOMAIN_VALUES } from "./utils/constants/domainNameValues";

import "./styles/css/index.css";

// configuring aws auth dynamically
Auth.configure({
  region: "us-east-1",
  userPoolId: DOMAIN_CONFIG_OBJ.awsCognito.cognitoPoolId,
  userPoolWebClientId: DOMAIN_CONFIG_OBJ.awsCognito.cognitoClientId,
  authenticationFlowType: "USER_SRP_AUTH",
  oauth: {
    domain: DOMAIN_CONFIG_OBJ.awsCognito.cognitoDomain,
    redirectSignIn: QBOOK_URL + "/oauth",
    redirectSignOut: QBOOK_URL + "/oauth",
    responseType: "code",
    scope: ["email", "openid", "read:user", "user:email"],
  },
});

const config = {
  loader: { load: ['[tex]/html', '[tex]/ams', '[tex]/newcommand'] },
  tex: {
    packages: { '[+]': ['html', 'ams', 'newcommand'] },
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']],
    processEscapes: true,
    processEnvironments: true,
    macros: {
      bmatrix: ["\\begin{bmatrix}#1\\end{bmatrix}", 1]
    },
    tags: 'ams'
  }
};


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    {/* Using Helmet to dynamically set head elements */}
    <Helmet>
      <meta charSet="utf-8" />
      <title>qbook | {DOMAIN_CONFIG_OBJ.domainName}</title>
      {/* Setting favicon based on QBOOK_DOMAIN */}
      <link
        rel="icon"
        type={
          DOMAIN_CONFIG_OBJ.domainName === QBOOK_DOMAIN_VALUES.qusteam
            ? "image/jpg"
            : "image/png"
        }
        href={DOMAIN_CONFIG_OBJ.favicon}
        sizes="16x16"
      />
    </Helmet>
    <MathJaxContext config={config}>
      <App />
    </MathJaxContext>
  </Provider>
);
